import AuditLog from '@/pages/AuditLog'
import ForgotPassword from '@/pages/auth/ForgotPassword'
import Login from '@/pages/auth/Login'
import ResetPassword from '@/pages/auth/ResetPassword'
import SetPassword from '@/pages/auth/SetPassword'
import Signup from '@/pages/auth/Signup'
import SignupSuccess from '@/pages/auth/SignupSuccess'
import VerifyUser from '@/pages/auth/VerifyUser'
import SetupCardPage from '@/pages/billing/SetupCardPage'
import Clients from '@/pages/Clients'
import ClosedAccountPage from '@/pages/ClosedAccount'
import ConvertForm from '@/pages/ConvertForm'
import CreateForm from '@/pages/CreateForm'
import FillResponseCustomer from '@/pages/customer/FillResponseCustomer'
import ResponseCustomerSubmitted from '@/pages/customer/ResponseCustomerSubmitted'
import Dashboard from '@/pages/Dashboard'
import ElationSettings from '@/pages/ElationSettings'
import ExportsPage from '@/pages/Exports'
import ExportsDetail from '@/pages/Exports/ExportsDetail'
import FormBuilderRouter from '@/pages/FormBuilderRouter'
import FormsPage from '@/pages/FormsPage'
import InternalForm from '@/pages/InternalForm'
import KioskModeMain from '@/pages/kioskMode/KioskModeMain'
import PacketRouter from '@/pages/PacketRouter'
import PacketsPage from '@/pages/PacketsPage'
import PDFFiller from '@/pages/PDFFiller'
import FileUpload from '@/pages/PDFFiller/Components/FileUpload'
import PreviewForm from '@/pages/PreviewForm'
import PreviewViewer from '@/pages/PreviewViewer/PreviewViewer'
import Profile from '@/pages/Profile'
import BusinessAssociateAgreementPage from '@/pages/profile/OrganizationTab/BusinessAssociateAgreementPage'
import Reports from '@/pages/Reports'
import Response from '@/pages/response/Response'
import AppointmentScheduled from '@/pages/Scheduler/AppointmentScheduled'
import Scheduler from '@/pages/Scheduler/Scheduler'
import Settings from '@/pages/Settings'
import GoogleDriveSettings from '@/pages/Settings/Integrations/components/GoogleDriveSettings'
import GoogleSheetsSettings from '@/pages/Settings/Integrations/components/GoogleSheetsSettings'
import TabletModeMain from '@/pages/tabletMode/TabletModeMain'
import TemplatesPage from '@/pages/TemplatesPage'

import { ClientDetails } from './pages/ClientDetails/ClientDetails'
import { FormsAnalytics } from './pages/FormsPage/FormsAnalytics'
import AnonymousPublicForm from './pages/sections/AnonymousPublicForm'
import PublicForm from './pages/sections/PublicForm'
import StripeIntegrationSettings from './pages/Settings/Integrations/Stripe/StripeIntegrationSettings'
import { VerifyEmail } from './pages/VerifyEmail/VerifyEmail'

const routes = [
  {
    component: Dashboard,
    exact: true,
    path: '/',
    private: true,
  },
  {
    component: BusinessAssociateAgreementPage,
    exact: true,
    path: '/profile/baa',
    private: true,
  },
  {
    component: Profile,
    exact: true,
    path: '/profile',
    private: true,
  },
  {
    component: Settings,
    exact: true,
    path: '/settings',
    private: true,
  },
  {
    component: ElationSettings,
    exact: true,
    path: '/settings/elation',
    private: true,
  },
  {
    component: StripeIntegrationSettings,
    exact: true,
    path: '/settings/stripe',
    private: true,
  },
  {
    component: GoogleDriveSettings,
    exact: true,
    path: '/settings/google-drive',
    private: true,
  },
  {
    component: GoogleSheetsSettings,
    exact: true,
    path: '/settings/google-sheets',
    private: true,
  },
  {
    component: FormsPage,
    exact: true,
    path: '/ourforms', // deprecated
    private: true,
  },
  {
    component: FormsPage,
    exact: true,
    path: '/forms',
    private: true,
  },
  {
    component: CreateForm,
    exact: true,
    path: '/forms/create',
    private: true,
  },
  {
    component: ConvertForm,
    exact: true,
    path: '/forms/convert',
    private: true,
  },
  {
    component: TemplatesPage,
    exact: true,
    path: '/templates',
    private: true,
  },
  {
    component: FormBuilderRouter,
    exact: true,
    path: '/builder', // deprecated
    private: true,
  },
  {
    component: FormBuilderRouter,
    exact: true,
    path: '/forms/new',
    private: true,
  },
  {
    component: FormBuilderRouter,
    exact: true,
    path: '/builder/edit/:formId', // deprecated
    private: true,
  },
  {
    component: FormsAnalytics,
    exact: true,
    path: '/forms/analytics/:resourceId',
    private: true,
  },
  {
    component: FormBuilderRouter,
    path: '/forms/:resourceId',
    private: true,
  },
  {
    component: PreviewViewer,
    path: '/r/preview/:resourceId',
    exact: true,
    private: true,
  },
  {
    component: PreviewForm,
    path: '/r/template/preview/:templateId',
    exact: true,
    private: true,
  },
  {
    component: PacketsPage,
    exact: true,
    path: '/packets',
    private: true,
  },
  {
    component: PacketRouter,
    path: '/packets/new',
    private: true,
  },
  {
    component: PacketRouter,
    path: '/packets/:packetId',
    private: true,
  },
  {
    component: Clients,
    exact: true,
    path: '/clients',
    private: true,
  },
  {
    component: ClientDetails,
    exact: true,
    path: '/clients/:clientId',
    private: true,
  },
  {
    component: ExportsPage,
    exact: true,
    path: '/exports',
    private: true,
  },
  {
    component: ExportsDetail,
    exact: true,
    path: '/exports/:formId',
    private: true,
  },
  {
    component: SetupCardPage,
    exact: true,
    path: '/setup-card',
    private: true,
    ignoreSetupCard: true,
    skipVerifyEmail: false,
  },
  {
    component: InternalForm,
    exact: true,
    path: '/internal-form/:responseId',
    private: true,
  },
  {
    component: FillResponseCustomer,
    exact: true,
    path: '/fillFormOfficeUseQuestions/:messageCode',
    private: true,
  },
  {
    component: FillResponseCustomer,
    exact: true,
    path: '/fillPacketOfficeUseQuestions/:messageCode',
    private: true,
  },
  {
    component: Response,
    exact: true,
    path: '/response/:responseId',
    private: true,
  },
  {
    component: FillResponseCustomer,
    exact: true,
    path: '/r/:messageCode',
    private: false,
  },
  {
    component: ResponseCustomerSubmitted,
    exact: true,
    path: '/r/:responseId/submitted',
    private: false,
  },
  {
    component: PublicForm,
    exact: true,
    path: '/f/:slug',
    private: false,
  },
  {
    component: AnonymousPublicForm,
    exact: true,
    path: '/a/f/:slug',
    private: false,
  },
  {
    component: TabletModeMain,
    path: '/t',
    private: true,
  },
  {
    component: KioskModeMain,
    path: '/k/:slug',
    private: false,
  },
  {
    component: Login,
    exact: true,
    path: '/login',
    private: false,
  },
  {
    component: ForgotPassword,
    exact: true,
    path: '/forgot-password',
    private: false,
  },
  {
    component: Signup,
    exact: true,
    path: '/signup',
    private: false,
  },
  {
    component: SignupSuccess,
    exact: true,
    path: '/signup/success',
    private: true,
    skipVerifyEmail: true,
    ignoreSetupCard: true,
  },
  {
    component: SetupCardPage,
    exact: true,
    path: '/signup/setup-card',
    private: true,
    ignoreSetupCard: true,
    skipVerifyEmail: false,
  },
  {
    component: ResetPassword,
    exact: true,
    path: '/password/reset/verify',
    private: false,
  },
  {
    component: VerifyUser,
    exact: true,
    path: '/signup/verify',
    private: false,
    skipVerifyEmail: true,
  },
  {
    component: SetPassword,
    exact: true,
    path: '/signup/password/set',
    private: false,
  },
  {
    component: FileUpload,
    exact: true,
    path: '/pdf-filler/upload', // deprecated
    private: false,
  },
  {
    component: FileUpload,
    exact: true,
    path: '/pdf/new',
    private: false,
  },
  {
    component: PDFFiller,
    path: '/pdf/:resourceId/:viewMode', // deprecating. We want to get rid of this.
    exact: false,
    private: true,
  },
  {
    component: PDFFiller,
    exact: true,
    path: '/pdf-filler/:resourceId/:viewMode', // deprecated
    private: false,
  },
  {
    component: PublicForm,
    exact: true,
    path: '/d/:documentId', // deprecated
    private: false,
  },
  {
    component: Reports,
    exact: true,
    path: '/reports',
    private: true,
  },
  {
    component: AuditLog,
    exact: true,
    path: '/integration-logs',
    private: true,
  },
  {
    component: Scheduler,
    exact: true,
    path: '/s/:messageCode',
    private: false,
  },
  {
    component: AppointmentScheduled,
    exact: true,
    path: '/s/:messageCode/success',
    private: false,
  },
  {
    component: VerifyEmail,
    exact: true,
    path: '/verify-email',
    private: true,
    skipVerifyEmail: true,
    ignoreSetupCard: true,
  },
  {
    component: ClosedAccountPage,
    exact: true,
    path: '/closed-account',
    private: true,
    skipVerifyEmail: true,
    ignoreSetupCard: true,
    skipVerifyClosedAccount: true,
  },
]

function createRoutes() {
  return routes.map((route) => {
    return {
      ...route,
      ignoreSetupCard: route.ignoreSetupCard || false,
      skipVerifyEmail: route.skipVerifyEmail || false,
    }
  })
}

export default createRoutes()
